import { render, staticRenderFns } from "./MainBookPrint.vue?vue&type=template&id=63f2c8f1&scoped=true"
import script from "./MainBookPrint.vue?vue&type=script&lang=js"
export * from "./MainBookPrint.vue?vue&type=script&lang=js"
import style0 from "./MainBookPrint.vue?vue&type=style&index=0&id=63f2c8f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2c8f1",
  null
  
)

export default component.exports